import { REQUEST, SUCCESS, FAILURE } from '../../actions/constants'

import {
  REPORT_CHART_STATS,
  REPORT_DATA,
} from './actions'


const initialState = {
  reportData: null,
  prevReportAreaKey: null,
  isFetchingReportData: false,
  chartStats: null,
  isFetchingChartStats: false,
}

function marketReportReducer(state = initialState, action) {
  const reducerState = Object.assign({}, state)
  let responseData
  switch(action.type) {
    case REPORT_DATA[REQUEST]:
      const { areaType, areaId } = action.params
      reducerState.prevReportAreaKey = areaType + areaId
      reducerState.isFetchingReportData = true
      // reducerState.reportData = null
      break
    case REPORT_DATA[SUCCESS]:
      reducerState.isFetchingReportData = false
      responseData = action.response.data.data
      reducerState.reportData = responseData
      break
    case REPORT_DATA[FAILURE]:
      reducerState.isFetchingReportData = false
      reducerState.reportData = null
      break


    // //////////////////////////////////////////////////////////////
    case REPORT_CHART_STATS[REQUEST]:
      reducerState.isFetchingChartStats = true
      reducerState.chartStats = null
      break
    case REPORT_CHART_STATS[SUCCESS]:
      reducerState.isFetchingChartStats = false
      reducerState.chartStats = action.response.data.data
      break
    case REPORT_CHART_STATS[FAILURE]:
      reducerState.isFetchingChartStats = false
      reducerState.chartStats = null
      break

    // //////////////////////////////////////////////////////////////
  }

  return reducerState
}


export default marketReportReducer
